<!--navBar-->
<header>
  <div class="top-nav-bar d-flex justify-content-between align-items-center">
    <nav class="navbar navbar-expand-lg justify-content-between">
      <!--Breadcrumb Section-->
      <div class="breadcrumb-section d-flex justify-content-between align-items-center">
        <img *ngIf="isDept" class="me-2" src="../../../../assets/Pos_sidebar/tdesign_component-breadcrumb.svg" />
        <nav aria-label="breadcrumb" class="d-flex">
          <ol class="breadcrumb d-flex align-items-center mb-0">
            <li class="breadcrumb-item" *ngIf="isDept">
              <a routerLink="/production/home/departments" [style.color]="color">{{ activeDeptTab | translate }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="isCategory">
              <a routerLink="/production/home/categories" [style.color]="handleColor" *ngIf="!isItemEntry">{{
                activeCategoryTab | translate }}</a>
              <a [style.color]="handleColor" *ngIf="isItemEntry" style="cursor: auto">{{ activeCategoryTab | translate
                }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="isSubCategory">
              <a routerLink="/production/home/sub-categories" [style.color]="handleColor" *ngIf="!isItemEntry">{{
                activeSubCategoryTab | translate }}</a>
              <a [style.color]="handleColor" *ngIf="isItemEntry" style="cursor: auto">{{ activeSubCategoryTab |
                translate }}</a>
            </li>
            <li class="breadcrumb-item" *ngIf="isActiveWares">
              <a>ENTRY</a>
            </li>
          </ol>
        </nav>
      </div>
      <!-- Override Section -->
      <div class="overidewrapper" *ngIf="isLicensePlateAssigned">
        <h2>
          Override : <span> {{ overrideDetails.overrideDesc ?? 'Default' }}</span>
        </h2>
      </div>
      <!--Profile Section-->
      <div class="profile-section">
        <div class="dropdow-wrapper">
          <div class="d-flex align-items-center">
            <i class="fa-regular fa-building" style="color: #175f91; font-size: 22px"></i>
            <h6 class="mb-0 text-nowrap ps-2 pe-4" style="font-size: 18px; font-weight: 400">
              {{ companyName }}
            </h6>
          </div>
          <div class="ps-1 language-select me-3" [hidden]="showItemEntery">
            <select class="form-select" style="width: 100%" [(ngModel)]="tempSelectedStore" (change)="selectStore()"
              [disabled]="isLicensePlateAssigned" *ngxPermissionsOnly="['Item:ChangeStore']">
              <option *ngFor="let store of stores" [ngValue]="store.storeId" class="notranslate">
                {{ store.storeName }}
              </option>
            </select>
          </div>

          <!-- Read-only display when user does NOT have permission -->
          <div class="ps-1 language-select me-3" [hidden]="showItemEntery" *ngxPermissionsExcept="['Item:ChangeStore']">
            <div class="w-100 d-flex justify-content-between align-items-center rounded border p-2">
              <span style="width: 290px; overflow: hidden" class="notranslate">
                {{ defaultStoreName }}
              </span>
            </div>
          </div>
        </div>
        <div class="b-right"></div>
        <!--user profile-->
        <div class="dropdown" (click)="handleDropdownToggle()">
          <div class="user-profile" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="true">
            <div class="d-flex align-items-center pe-3">
              <div class="profile-pic" *ngIf="!userInfo.profileImgUrl" id="demoImg"
                data-testid="user-profile-pic-default">
                <img src="../../../assets/adminprofile/kevin.png" data-testid="user-profile-img-default" />
              </div>
              <div class="profile-pic border" *ngIf="userInfo.profileImgUrl" data-testid="user-profile-pic">
                <img class="w-100" [src]="userInfo.profileImgUrl" data-testid="user-profile-img" />
              </div>
              <div class="user-name notranslate">
                <h3 class="name notranslate" *ngIf="!userdata.displayName">
                  {{ userdata.fullName }}
                </h3>
                <h3 class="name notranslate" *ngIf="userdata.displayName">
                  {{ userdata.displayName }}
                </h3>
                <h6 class="secondary mb-0 notranslate">
                  {{ userdata.userRole }}
                </h6>
              </div>
            </div>
            <i [class.rotate-icon]="isDropdownOpen" class="fa-solid fa-chevron-down text-black"></i>
          </div>
          <ul class="dropdown-menu admin-menu" aria-labelledby="dropdownMenuButton2">
            <li>
              <a class="dropdown-item" data-bs-target="#languageModal" data-bs-toggle="modal">
                <img style="width: 20px; margin-right: 15px" src="../../assets/admin-nav/language.svg" /><span
                  class="notranslate">{{
                  activeLanguage | uppercase | translate
                  }}</span>
              </a>
            </li>
            <li *ngIf="userInfo.hasAccessToAdminModule">
              <a class="dropdown-item" (click)="changeModule()">
                <i class="fa-solid fa-right-left" style="
                    color: #175f91;
                    font-size: 18px;
                    margin-right: 17px;
                    font-weight: 100;
                  "></i>{{ 'SWITCH_TO_ADMIN' | translate }}
              </a>
            </li>
            <ng-template [ngxPermissionsOnly]="[
                'Item:BasicOverride',
                'WeekColor:Override'
              ]" [ngxPermissionsOnlyOperator]="'OR'">
              <li class="d-flex align-items-center">
                <a class="dropdown-item" id="overrideBtn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight">
                  <img class="me-3" src="../../assets/admin-nav/override.svg" />{{ 'OVERRIDE' | translate }}
                </a>
                <div class="form-check form-switch" *ngIf="isLicensePlateAssigned">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked1"
                    [(ngModel)]="isLicensePlateAssigned" (ngModelChange)="
                      !$event && prodOverride.toggleOverrideOff()
                    " data-bs-dismiss="offcanvas" [disabled]="!isLicensePlateAssigned" />
                </div>
              </li>
            </ng-template>
            <li class="d-flex align-items-center" *ngxPermissionsOnly="['Item:ScanOverride']">
              <a class="dropdown-item" data-bs-target="#scanLicensePlateModal" data-bs-toggle="modal"
                (click)="resetScanLicensePlateModal()">
                <i class="fa-solid fa-barcode" style="
                    color: #175f91;
                    font-size: 18px;
                    margin-right: 17px;
                    font-weight: 100;
                  "></i>
                {{ 'SCAN_LICENSE_PLATE' | translate }}
              </a>
              <div class="form-check form-switch" *ngIf="isLicensePlateAssigned">
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked1"
                  [(ngModel)]="isLicensePlateAssigned" (ngModelChange)="!$event && prodOverride.toggleOverrideOff()"
                  data-bs-dismiss="offcanvas" [disabled]="!isLicensePlateAssigned" />
              </div>
            </li>
            <ng-template [ngxPermissionsOnly]="['Item:BinScan']">
              <li class="d-flex justify-content-between">
                <a class="dropdown-item" data-bs-target="#scanProductionBinModal" data-bs-toggle="modal"
                  (click)="resetScanProductionBinModal()">
                  <i class="fa-solid fa-barcode" style="
                      color: #175f91;
                      font-size: 18px;
                      margin-right: 17px;
                      font-weight: 100;
                    "></i>
                  {{ 'SCAN_PRODUCTION_BIN' | translate }}
                </a>
                <div class="form-check form-switch" style="padding-block: 4px" *ngIf="sourceBinName">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked1"
                    [(ngModel)]="sourceBinName" (ngModelChange)="unAssignProductionBin()" data-bs-dismiss="offcanvas"
                    [disabled]="!sourceBinName" />
                </div>
              </li>
            </ng-template>
            <li (click)="Logout()">
              <a class="dropdown-item">
                <img class="me-3" src="../../assets/admin-nav/ic_logout.svg" />{{ 'LOGOUT' | translate }}
              </a>
            </li>
            <hr class="dropdown-divider" />
            <li>
              <a class="dropdown-item notranslate">
                {{ companyName }}/ {{ selectedStoreName }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <!--Label section-->
  <div class="row info-section justify-content-between align-items-center" [hidden]="showItemEntery">
    <div class="col-md-2">
      <p>{{ "Date" | translate }}: {{ formattedDate }}</p>
    </div>
    <div class="col-md-2 text-center">
      <p>
        {{ "Total_value" | translate }}:
        {{ perDayItemEnteries | number: "1.0-0" }} {{ "in" | translate }}
        {{ loginTime }}
      </p>
    </div>
    <div class="col-md-2 text-center" *ngIf="stationName">
      <p>{{ "STATION_NAME" | translate }} : {{ stationName }}</p>
    </div>

    <div class="col-md-2 text-center" *ngIf="isLicensePlateAssigned">
      License Plate :
      <span>
        {{ overrideDetails.licensePlateDesc }} ({{ licensePlateCount }})</span>
    </div>
    <div class="col-md-2 text-center" *ngIf="sourceBinName">
      Production Bin :
      <span>
        {{ sourceBinName }}
      </span>
    </div>

    <div class="col-md-2 align-items-center" style="pointer-events: none" *ngIf="!isOverride">
      <div class="d-flex justify-content-end align-items-center">
        <span *ngIf="showWeekColor" class="d-flex align-items-center">
          <p>{{ "Week" | translate }}:</p>
          <div class="d-flex justify-content-center align-items-center position-relative">
            <span [style.backgroundColor]="selectedBgColorCurWeek" id="weekColor"
              style="color: #fff; font-weight: 500; cursor: pointer">
              {{ selectedcolor }}
            </span>
          </div>
        </span>
      </div>
    </div>

    <div class="col-md-2 align-items-center" *ngIf="isOverride">
      <div class="d-flex justify-content-end align-items-center">
        <span *ngIf="showWeekColor">
          <p>{{ "Week" | translate }}:</p>
          <div class="d-flex justify-content-center align-items-center position-relative">
            <span [style.backgroundColor]="overrideDetails.weekColor" id="weekColor"
              style="color: #fff; font-weight: 500; cursor: pointer">
              {{ overrideDetails.weekColorName }}
            </span>
          </div>
        </span>
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <span style="font-size: 12px; margin-right: 26px; margin-top: 5px">
          {{ overrideDetails.date | date: "MM-dd-yy" }}
        </span>
      </div>
    </div>
  </div>
</header>
<!-- Language Modal -->
<div class="modal fade" id="languageModal" tabindex="-1" aria-labelledby="languageModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body custom-modal-body">
        <h3 class="modal-title border-bottom" id="languageModalLabel">
          {{ "Language" | translate }}
        </h3>
        <div class="language-dropdown-wrapper">
          <ul class="list-unstyled mb-0">
            <li *ngFor="let language of availableLanguages">
              <a class="dropdown-item d-flex justify-content-between align-items-center" data-bs-dismiss="modal"
                aria-label="Close" (click)="onLanguageChange(language.code)">
                <div>
                  <img width="70" style="margin-right: 30px" [src]="language.url" /><span class="notranslate">{{
                    language.fullName | uppercase | translate
                    }}</span>
                </div>
                <img *ngIf="language.isPrimary" width="20" src="../../assets/languages/Vector (6).svg" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Production Override Component -->
<app-production-override #prodOverride [stores]="stores" [productionStore]="tempSelectedStore"
  [productionStoreName]="selectedStoreName" [companyId]="companyId"
  (overrideStateChanged)="onOverrideStateChanged($event)" (storeChanged)="onStoreChanged($event)"
  (needsRefresh)="onNeedsRefresh()"></app-production-override>

<!-- Scan License Plate Modal -->
<div class="modal fade modal-lg" id="scanLicensePlateModal" tabindex="-1" aria-labelledby="scanLicensePlateModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2 border-bottom">
        <div>
          <h3 class="modal-title" id="scanLicensePlateModalLabel">
            Scan License Plate
          </h3>
          <small class="text-muted">Search and assign a license plate</small>
        </div>
        <button type="button" class="d-flex align-items-center justify-content-center p-0 align-self-start"
          style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid #d1d5db; background: transparent; cursor: pointer; margin-top: 4px;"
          data-bs-dismiss="modal" aria-label="Close" (click)="handleLPModalCloseClick()"
          [matTooltip]="(isLPScanRequired && !(isOverride && overrideDetails?.licensePlateId)) ? 'Cancel and log out' : 'Cancel'"
          matTooltipPosition="above">
          <i class="fa-solid fa-xmark text-muted" style="font-size: 16px;"></i>
        </button>
      </div>
      <div class="modal-body custom-modal-body">  
        <div class="input-group mt-2">
          <span class="input-group-text">
            <i class="fa-solid fa-magnifying-glass"></i>
          </span>
          <input type="text" class="form-control" placeholder="Scan or enter license plate"
            [(ngModel)]="scanLicensePlateTerm" (keyup.enter)="searchLicensePlates()" />
          <button class="btn btn-primary" type="button" (click)="searchLicensePlates()"
            [disabled]="isScanningLicensePlate">
            {{ isScanningLicensePlate ? "Searching..." : "Search" }}
          </button>
        </div>
        <div class="mt-2 d-flex align-items-center text-muted" *ngIf="isScanningLicensePlate">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Searching license plates...
        </div>

        <div class="mt-3 text-muted" *ngIf="
            scanSearchAttempted &&
            scanLicensePlateResults.length === 0 &&
            !isScanningLicensePlate
          ">
          No license plates found.
        </div>

        <div class="mt-3 scan-results" *ngIf="scanLicensePlateResults.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <small class="text-muted">Results</small>
            <small class="text-muted">{{ scanLicensePlateResults.length }} found</small>
          </div>
          <div class="list-group list-group-flush">
            <button type="button"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              *ngFor="let lp of scanLicensePlateResults" (click)="assignScannedLicensePlate(lp)"
              data-bs-dismiss="modal">
              <div>
                <div class="fw-semibold">
                  {{ getScanLicensePlateLabel(lp) }}
                </div>
                <div class="small text-muted" *ngIf="
                    lp.description && lp.description !== lp.referenceNumber
                  ">
                  {{ lp.description }}
                </div>
              </div>
              <span class="badge bg-secondary">Assign</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Scan Production bin Modal -->
<div class="modal fade modal-lg" id="scanProductionBinModal" tabindex="-1" aria-labelledby="scanProductionBinModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2 border-bottom">
        <div>
          <h3 class="modal-title" id="scanProductionBinModalLabel">
            Scan Production Bin
          </h3>
          <small class="text-muted">Search and assign a production bin</small>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetScanProductionBinModal()"></button>
      </div>
      <div class="modal-body custom-modal-body">
        <div class="input-group mt-2">
          <span class="input-group-text">
            <i class="fa-solid fa-magnifying-glass"></i>
          </span>
          <input type="text" class="form-control" placeholder="Scan or enter production bin"
            [(ngModel)]="scanProductionBinTerm" (keyup.enter)="searchProductionBins()" />
          <button class="btn btn-primary" type="button" (click)="searchProductionBins()"
            [disabled]="isScanningProductionBin">
            {{ isScanningProductionBin ? "Searching..." : "Search" }}
          </button>
        </div>
        <div class="mt-2 d-flex align-items-center text-muted" *ngIf="isScanningProductionBin">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Searching production bins...
        </div>

        <div class="mt-3 text-muted" *ngIf="
            scanSearchAttempted &&
            scanProductionBinResults.length === 0 &&
            !isScanningProductionBin
          ">
          No production bins found.
        </div>

        <div class="mt-3 scan-results" *ngIf="scanProductionBinResults.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <small class="text-muted">Results</small>
            <small class="text-muted">{{ scanProductionBinResults.length }} found</small>
          </div>
          <div class="list-group list-group-flush">
            <button type="button"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              *ngFor="let bin of scanProductionBinResults" (click)="assignScannedProductionBin(bin)"
              data-bs-dismiss="modal">
              <div>
                <div class="fw-semibold">
                  {{ getScanProductionBinLabel(bin) }}
                </div>
                <div class="small text-muted" *ngIf="
                    bin.description && bin.description !== bin.referenceNumber
                  ">
                  {{ bin.description }}
                </div>
              </div>
              <span class="badge bg-secondary">Assign</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- License Plate Required Confirmation Modal -->
<div class="modal fade" id="lpRequiredConfirmModal" tabindex="-1" aria-labelledby="lpRequiredConfirmModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="border-radius: 16px; padding: 20px;">
      <div class="modal-body text-start pb-0">
        <div class="d-flex align-items-start mb-3">
          <div class="me-3 d-flex align-items-center justify-content-center" style="background-color: #fef3c7; width: 48px; height: 48px; border-radius: 50%; flex-shrink: 0;">
            <i class="fa-solid fa-triangle-exclamation" style="color: #d97706; font-size: 24px;"></i>
          </div>
          <div>
            <h5 class="fw-bold mb-2" id="lpRequiredConfirmModalLabel" style="color: #111827;">License plate required</h5>
            <p class="text-muted" style="font-size: 15px; line-height: 1.5; color: #4b5563;">
              You must select a license plate to continue production. Do you want to cancel and go back, or log out?
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 d-flex justify-content-end pt-0">
        <button type="button" class="btn btn-outline-secondary px-4 py-2 me-2" style="border-radius: 10px; font-weight: 500; color: #374151 !important; border: 1px solid #d1d5db !important; background-color: transparent;" (click)="goBackToLPScan()">
          Cancel
        </button>
        <button type="button" class="btn btn-danger px-4 py-2" style="border-radius: 10px; font-weight: 500; background-color: #dc2626;" (click)="confirmLogout()">
          Log out
        </button>
      </div>
    </div>
  </div>
</div>
